const jobs = [
    {
        id: 1,
        company: 'Crest Data',
        mainCompany: 'Crest Data',
        location: 'Ahmedabad, India',
        position: 'Software Engineer Intern',
        duration: 'May 2023 - Nov 2023',
        companyUrl: 'https://www.crestdata.ai/',
        bullets: [
            "Refined employee portal using Python and React.js in cross-functional collaboration, optimizing 60% performance.",
            "Orchestrated the Docker deployment strategy, decreasing the deployment time from 40 minutes to 7 minutes."
        ]
    },
    {
        id: 2,
        company: 'Crest Data',
        mainCompany: 'Crest Data',
        location: 'Ahmedabad, India',
        position: 'Software Engineer',
        duration: 'Jun 2021 - May 2023',
        companyUrl: 'https://www.crestdata.ai/',
        bullets: [
            "Recognized with the Crest Achievement Program award for designing an outlier detection algorithm, reducing false positives and enhancing anomaly detection for over 1 million daily events.",
            "Utilized Python to migrate visualizations and alerts from Sumologic to Elasticsearch, saving 60% infrastructure costs.",
            "Enhanced regression test automation with Selenium, detecting critical bugs 2x faster and boosting release stability."
        ]
    },
    {
        id: 3,
        company: 'Crest Data',
        mainCompany: 'Crest Data',
        location: 'Ahmedabad, India',
        position: 'Senior Software Engineer',
        duration: 'May 2023 - Nov 2023',
        companyUrl: 'https://www.crestdata.ai/',
        bullets: [
            "Engineered Splunk to Elasticsearch migration tool using Python and React.js reducing data transition effort by 88%.",
            "Collaborated with 5+ developers to build an OpenAI connector in Kibana, integrating advanced analytics capabilities.",
            "Designed Rapid7 integration for Elasticsearch, streamlining threat detection workflows, resulting in 3k+ downloads.",
            
        ]
    },
    {
        id: 4,
        company: 'ASU',
        mainCompany: 'DigInG',
        location: 'Arizona, USA',
        position: 'Software Engineer',
        duration: 'Feb 2024 - Present',
        companyUrl: 'https://diging.asu.edu/',
        bullets: [
            "Developed RESTful APIs, performed integration and unit testing using PyTest, achieving 10% higher test coverage.",
            "Optimized MongoDB queries, slashing response times by 20% and improving overall system performance.",
            "Improved map load times by implementing asynchronous data fetching and paginated API to handle 4GB+ of data.",
            "Implemented JWT-based token authentication in Conceptpower, enabling secure third-party API integrations."
        ]
    },
    {
        id: 5,
        company: 'ASU',
        mainCompany: 'Silverton Software',
        location: 'Arizona, USA',
        position: 'Software Engineer',
        duration: 'Jun 2025 - Present',
        companyUrl: 'https://silvertonsoftware.com/',
        bullets: [
            "Engineered a fault-tolerant, offline-first app (React Native + FastAPI), ensuring 99.9% uptime under unstable network.",
            "Implemented SQLite-based caching and deduplication, cutting redundant API calls by 68%, improving system scalability.",
            "Designed REST APIs with JWT auth, RBAC, CORS, and rate limiting, reducing 95th-percentile latency by 40%.",
            "Streamlined retry mechanisms with exponential backoff that reduced retry spikes by 35%, enhancing system reliability."
        ]
    }
]

export default jobs